// Dizzplace - interakcje strony glownej: kropki karuzel, filtry realizacji
// i powiekszenie zdjecia realizacji we wspolnym oknie motywu.

(() => {
  const initCarousels = (root) => {
    root.querySelectorAll('[data-carousel]').forEach((viewport) => {
      const track = viewport.querySelector('[data-carousel-track]');
      const dots = viewport.parentElement?.querySelector('[data-carousel-dots]');
      if (!track || !dots || dots.dataset.ready === 'true') return;

      const cells = Array.from(track.children);
      if (cells.length < 2) return;

      /* Jedna kreska = jedno PRZYSTANIE toru, czyli miejsce, w ktorym tor
         naprawde sie zatrzymuje (kafle maja `scroll-snap-align: start`).
         Liczenie po szerokosci okna dawalo kreski, ktorych nie da sie trafic:
         ostatni ekran jest niepelny, wiec skrajne przewiniecie nie dochodzilo
         do ostatniej kreski. Rozlozenie ich rownomiernie po zakresie
         przewijania naprawilo koniec, ale rozjechalo srodek - kreska
         przeskakiwala o dwie, bo przystanki nie leza w rownych odstepach.
         Dlatego pytamy o pozycje same kafle. Kafle, ktore nie miesza sie juz
         przed koncem toru, zbiegaja sie w JEDNEJ ostatniej kresce - stad ich
         zwykle mniej niz kafli. */
      const BLISKO = 24;

      const przystanki = () => {
        const maks = viewport.scrollWidth - viewport.clientWidth;
        if (maks < 1) return [];

        const zapas = parseFloat(getComputedStyle(viewport).scrollPaddingLeft) || 0;
        const lewa = viewport.getBoundingClientRect().left - viewport.scrollLeft;
        const lista = [];

        cells.forEach((cell) => {
          if (cell.hidden || cell.offsetParent === null) return;
          const pozycja = Math.round(cell.getBoundingClientRect().left - lewa - zapas);
          const w = Math.min(maks, Math.max(0, pozycja));
          // Kafle za koncem toru wskazuja to samo miejsce - jedna kreska.
          // Prog, nie rownosc: ostatni kafel czesto konczy sie kilkanascie
          // pikseli przed koncem toru i dawal druga kreske obok tej samej.
          if (lista.length === 0 || w - lista[lista.length - 1] > BLISKO) lista.push(w);
        });

        if (lista.length === 0 || maks - lista[lista.length - 1] > BLISKO) lista.push(maks);
        return lista;
      };

      /* Kreski przeliczamy TYLKO wtedy, gdy zmienia sie uklad toru: przy
         zmianie rozmiaru okna i wtedy, gdy kafle znikaja albo dochodza
         (filtr Realizacji, „Zobacz wiecej"). Wczesniej kazda klatka
         przewijania pytala o pozycje KAZDEGO kafla i o styl toru, czyli
         wymuszala przeliczenie ukladu strony 60 razy na sekunde - na
         slabszym telefonie bylo to widac jako szarpanie. W czasie samego
         przewijania czytamy juz tylko przesuniecie toru. */
      let miejsca = [];
      let szerokoscToru = 0;

      const podswietl = () => {
        if (miejsca.length < 2) return;
        let active = 0;
        let najblizej = Infinity;
        miejsca.forEach((pozycja, i) => {
          const odleglosc = Math.abs(viewport.scrollLeft - pozycja);
          if (odleglosc < najblizej) {
            najblizej = odleglosc;
            active = i;
          }
        });

        Array.from(dots.children).forEach((dot, i) => {
          dot.classList.toggle('dots__dot--active', i === active);
        });
      };

      const przelicz = () => {
        miejsca = przystanki();
        szerokoscToru = viewport.scrollWidth;

        if (miejsca.length < 2) {
          dots.innerHTML = '';
          return;
        }

        if (dots.children.length !== miejsca.length) {
          dots.innerHTML = '';
          miejsca.forEach((_, i) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'dots__dot';
            dot.addEventListener('click', () => {
              const cel = miejsca[i];
              if (cel !== undefined) viewport.scrollTo({ left: cel, behavior: 'smooth' });
            });
            dots.appendChild(dot);
          });
        }

        podswietl();
      };

      let czeka = false;
      const naPrzewijanie = () => {
        if (czeka) return;
        czeka = true;
        window.requestAnimationFrame(() => {
          czeka = false;
          /* Tor potrafi zmienic dlugosc bez zmiany rozmiaru okna (filtr,
             rozwijanie listy). Jedno tanie pytanie o dlugosc wystarczy,
             zeby to wylapac - pelne przeliczenie idzie dopiero wtedy. */
          if (Math.abs(viewport.scrollWidth - szerokoscToru) > 1) przelicz();
          else podswietl();
        });
      };

      dots.dataset.ready = 'true';
      dots.classList.add('dots');
      viewport.addEventListener('scroll', naPrzewijanie, { passive: true });
      window.addEventListener('resize', przelicz);
      if ('ResizeObserver' in window) new ResizeObserver(przelicz).observe(track);
      przelicz();
      initDrag(viewport, () => miejsca);
    });
  };

  /* Przeciaganie toru mysza - to samo, co w karuzelach na Swiperze daje
     `grabCursor` (~/.claude/mechanizmy/karuzela.md). Palec przewija tor sam,
     wiec obslugujemy tylko mysz. Na czas ciagniecia i dojazdu przyleganie
     jest wylaczone (inaczej tor wraca do kafla przy kazdym ruchu), a po
     puszczeniu tor dojezdza do przystanku - tych samych, co kreski.
     Dojazd liczymy sami, a nie przez `scrollTo` z `smooth`: przegladarka
     rusza wtedy od zera, wiec tor stawal po puszczeniu i dopiero potem
     jechal, a przyleganie wracalo w polowie drogi i szarpalo. Tu tor
     startuje z predkoscia reki i hamuje do zera dokladnie na kaflu. */
  const initDrag = (viewport, przystankiToru) => {
    const PROG = 5;
    const OKNO = 80; // ms, z ilu ostatnich ruchow liczymy predkosc
    const CZAS = 520; // ms dojazdu
    let start = null;
    let klatka = 0;

    const przewijalny = () => viewport.scrollWidth - viewport.clientWidth > 1;
    const oznacz = () => viewport.classList.toggle('carousel-grab', przewijalny());
    oznacz();
    if ('ResizeObserver' in window) new ResizeObserver(oznacz).observe(viewport);

    const zatrzymaj = () => {
      if (klatka) window.cancelAnimationFrame(klatka);
      klatka = 0;
    };

    const docelowy = (pozycja, v) => {
      const miejsca = przystankiToru();
      if (miejsca.length === 0) return pozycja;
      // Rozpedzony tor jedzie dalej: celujemy tam, gdzie by sie zatrzymal.
      const rzut = pozycja + v * 180;
      let cel = miejsca.reduce((a, b) => (Math.abs(b - rzut) < Math.abs(a - rzut) ? b : a));
      // Wyrazne machniecie zawsze przesuwa co najmniej o jeden kafel.
      if (v > 0.25 && cel <= pozycja + 1) cel = miejsca.find((m) => m > pozycja + 1) ?? cel;
      if (v < -0.25 && cel >= pozycja - 1) cel = [...miejsca].reverse().find((m) => m < pozycja - 1) ?? cel;
      return cel;
    };

    // Krzywa Hermite'a: startuje z predkoscia v0, konczy w celu z predkoscia zero.
    const dojedz = (cel, v0) => {
      zatrzymaj();
      const p0 = viewport.scrollLeft;
      const droga = cel - p0;
      let rozped = v0 * CZAS;
      // Rozped w zla strone albo za duzy zrobilby przestrzal za kafel.
      if (Math.sign(rozped) !== Math.sign(droga)) rozped = 0;
      if (Math.abs(rozped) > Math.abs(3 * droga)) rozped = 3 * droga;
      const t0 = performance.now();
      const krok = (teraz) => {
        const s = Math.min(1, (teraz - t0) / CZAS);
        const s2 = s * s;
        const s3 = s2 * s;
        viewport.scrollLeft = p0 + droga * (3 * s2 - 2 * s3) + rozped * (s3 - 2 * s2 + s);
        if (s < 1) {
          klatka = window.requestAnimationFrame(krok);
        } else {
          klatka = 0;
          viewport.scrollLeft = cel;
          viewport.classList.remove('carousel-dragging');
        }
      };
      klatka = window.requestAnimationFrame(krok);
    };

    viewport.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0 || !przewijalny()) return;
      // Chwycenie jadacego toru zatrzymuje go w miejscu.
      if (klatka) zatrzymaj();
      start = { x: e.clientX, scroll: viewport.scrollLeft, ruch: false, slady: [{ x: e.clientX, t: e.timeStamp }] };
    });

    viewport.addEventListener('pointermove', (e) => {
      if (!start) return;
      const dx = e.clientX - start.x;
      if (!start.ruch) {
        if (Math.abs(dx) < PROG) return;
        start.ruch = true;
        viewport.setPointerCapture(e.pointerId);
        viewport.classList.add('carousel-dragging');
      }
      viewport.scrollLeft = start.scroll - dx;
      start.slady.push({ x: e.clientX, t: e.timeStamp });
      while (start.slady.length > 2 && e.timeStamp - start.slady[0].t > OKNO) start.slady.shift();
    });

    const koniec = (e) => {
      if (!start) return;
      const { ruch, slady } = start;
      start = null;
      if (!ruch) {
        viewport.classList.remove('carousel-dragging');
        return;
      }

      // Klikniecie po przeciagnieciu nie moze otworzyc karty, na ktorej puszczono mysz.
      const zdusKlik = (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
      };
      viewport.addEventListener('click', zdusKlik, { capture: true, once: true });
      window.setTimeout(() => viewport.removeEventListener('click', zdusKlik, { capture: true }), 0);

      // Predkosc toru (px/ms) z ostatnich ruchow; mysz przytrzymana przed
      // puszczeniem = zero, zeby tor nie wystrzelil.
      const ost = slady[slady.length - 1];
      const pierwszy = slady[0];
      const dt = ost.t - pierwszy.t;
      const v = dt > 0 && e.timeStamp - ost.t < 60 ? -(ost.x - pierwszy.x) / dt : 0;
      dojedz(docelowy(viewport.scrollLeft, v), v);
    };

    viewport.addEventListener('pointerup', koniec);
    viewport.addEventListener('pointercancel', koniec);
    // Kolko myszy albo gladzik w trakcie dojazdu przejmuja tor.
    viewport.addEventListener('wheel', () => {
      if (!klatka) return;
      zatrzymaj();
      viewport.classList.remove('carousel-dragging');
    }, { passive: true });
    // Przegladarka chwyta obrazki i odnosniki do wlasnego przeciagania.
    viewport.addEventListener('dragstart', (e) => e.preventDefault());
  };

  const initProjectFilters = (root) => {
    root.querySelectorAll('[data-projects]').forEach((section) => {
      const pills = Array.from(section.querySelectorAll('[data-projects-filter]'));
      const cells = Array.from(section.querySelectorAll('[data-projects-category]'));
      const more = section.querySelector('[data-projects-more]');
      if (cells.length === 0) return;

      const step = parseInt(section.dataset.projectsVisible, 10) || 4;
      let expanded = false;

      // Komorka jest widoczna, gdy pasuje do filtra ORAZ miesci sie w biezacej
      // porcji. Link dokladajacy kolejne pokazujemy tylko wtedy, gdy filtr ma
      // wiecej realizacji, niz widac - inaczej prowadzilby donikad.
      const apply = (value) => {
        let shown = 0;
        let matched = 0;
        cells.forEach((cell) => {
          const matches = value === '' || cell.dataset.projectsCategory === value;
          if (matches) matched += 1;
          const fits = expanded || shown < step;
          cell.hidden = !(matches && fits);
          if (matches && fits) shown += 1;
        });
        if (more) more.hidden = expanded || matched <= step;
      };

      const current = () => {
        const active = pills.find((pill) => pill.classList.contains('projects__pill--active')) || pills[0];
        return active ? active.dataset.projectsFilter : '';
      };

      pills.forEach((pill) => {
        pill.addEventListener('click', () => {
          pills.forEach((other) => other.classList.toggle('projects__pill--active', other === pill));
          expanded = false;
          apply(pill.dataset.projectsFilter);
        });
      });

      if (more) {
        more.addEventListener('click', () => {
          expanded = true;
          apply(current());
        });
      }

      apply(current());
    });
  };

  // Powiekszenie realizacji. Do okna trafiaja TYLKO kafle widoczne w chwili
  // klikniecia, czyli te przepuszczone przez filtr kategorii i rozwiniecie -
  // inaczej przewijanie w powiekszeniu prowadziloby do zdjec, ktorych na
  // stronie nie widac.
  const initProjectZoom = (root) => {
    root.querySelectorAll('[data-projects]').forEach((section) => {
      const okno = section.querySelector('dizz-lightbox');
      if (!okno) return;

      section.querySelectorAll('[data-projects-zoom]').forEach((wyzwalacz) => {
        if (wyzwalacz.dataset.podlaczony === '1') return;
        wyzwalacz.dataset.podlaczony = '1';

        wyzwalacz.addEventListener('click', () => {
          const widoczne = Array.from(section.querySelectorAll('[data-projects-zoom]')).filter(
            (kafel) => !kafel.closest('[data-projects-category]')?.hidden
          );
          const indeks = Math.max(0, widoczne.indexOf(wyzwalacz));
          const zdjecia = widoczne.map((kafel) => ({
            src: kafel.dataset.zoomSrc,
            srcset: kafel.dataset.zoomSrcset || '',
            alt: kafel.querySelector('img')?.alt || '',
            width: kafel.dataset.zoomWidth || '',
            height: kafel.dataset.zoomHeight || '',
          }));

          customElements.whenDefined('dizz-lightbox').then(() => okno.otworz(indeks, zdjecia));
        });
      });
    });
  };

  // Filmy w kaflach [data-wideo] graja tylko wtedy, gdy sa na ekranie. Kafel
  // karuzeli stoi w drzewie dwa razy (kolumna na komputerze, kafelek w torze
  // na telefonie); schowana kopia nigdy nie wchodzi w kadr, wiec nie ciagnie
  // pliku. Przy ograniczonym ruchu w systemie filmy stoja na pierwszej klatce -
  // takze film w hero, ktory startuje sam.
  //
  // Filmy NIE wstrzymuja wczytania strony (snippets/wideo.liquid): do konca
  // wczytania i pierwszej wolnej chwili przegladarki nie maja adresu, a w ich
  // miejscu stoi kadr zastepczy. Prosba o start przed tym momentem czeka
  // w kolejce (`czekaja`) i rusza, gdy strona jest gotowa.
  const bezRuchu = window.matchMedia('(prefers-reduced-motion: reduce)');
  let stronaGotowa = false;
  const czekaja = new Set();

  const uzbroj = (film) => {
    if (film.dataset.uzbrojony === '1') return;
    film.dataset.uzbrojony = '1';
    film.querySelectorAll('source[data-src]').forEach((zrodlo) => {
      zrodlo.src = zrodlo.dataset.src;
      zrodlo.removeAttribute('data-src');
    });
    film.addEventListener('playing', () => film.classList.add('is-gra'), { once: true });
    film.preload = 'auto';
    film.load();
  };

  const graj = (film) => {
    if (bezRuchu.matches) return;
    if (!stronaGotowa) {
      czekaja.add(film);
      return;
    }
    uzbroj(film);
    film.play().catch(() => {});
  };

  const stoj = (film) => {
    czekaja.delete(film);
    film.pause();
  };

  const poWczytaniu = () => {
    const start = () => {
      stronaGotowa = true;
      czekaja.forEach((film) => graj(film));
      czekaja.clear();
    };
    const wolnaChwila = () =>
      'requestIdleCallback' in window ? window.requestIdleCallback(start, { timeout: 2000 }) : setTimeout(start, 200);
    if (document.readyState === 'complete') wolnaChwila();
    else window.addEventListener('load', wolnaChwila, { once: true });
  };
  poWczytaniu();

  const obserwator =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (wpisy) => {
            wpisy.forEach(({ target, isIntersecting }) => {
              if (isIntersecting) graj(target);
              else stoj(target);
            });
          },
          { rootMargin: '200px 0px' }
        )
      : null;

  const initWideo = (root) => {
    root.querySelectorAll('[data-wideo] video').forEach((film) => {
      if (film.dataset.podlaczony === '1' || !obserwator) return;
      film.dataset.podlaczony = '1';
      obserwator.observe(film);
    });
    // Film hero, ktory startuje sam - tylko na widocznym slajdzie (przy wielu
    // slajdach dalej steruje nim initHero).
    root.querySelectorAll('video[data-wideo-start]').forEach((film) => {
      const slajd = film.closest('[data-hero-slide]');
      if (!slajd || slajd.classList.contains('is-active')) graj(film);
    });
  };

  /* Hero: slajdy leza jeden na drugim, widoczny ma klase is-active (zanikanie
     robi arkusz stylow). Strzalki, kropki i przesuniecie palcem; samo
     przelaczanie co tyle sekund, ile stoi w ustawieniu sekcji (0 = wcale),
     wstrzymane pod kursorem, przy fokusie, w schowanej karcie i przy
     ograniczonym ruchu. Gra tylko film widocznego slajdu. */
  const initHero = (root) => {
    root.querySelectorAll('[data-hero]').forEach((hero) => {
      if (hero.dataset.heroGotowe === '1') return;
      const slajdy = [...hero.querySelectorAll('[data-hero-slide]')];
      if (slajdy.length < 2) return;
      hero.dataset.heroGotowe = '1';
      const kropki = [...hero.querySelectorAll('[data-hero-dot]')];
      const co = Number(hero.dataset.heroAutoplay) || 0;
      let biezacy = 0;
      let zegar = null;
      let wstrzymany = false;

      const pokaz = (n) => {
        biezacy = (n + slajdy.length) % slajdy.length;
        slajdy.forEach((slajd, i) => {
          const aktywny = i === biezacy;
          slajd.classList.toggle('is-active', aktywny);
          slajd.toggleAttribute('aria-hidden', !aktywny);
          slajd.inert = !aktywny;
          const film = slajd.querySelector('video');
          if (!film) return;
          if (aktywny) graj(film);
          else stoj(film);
        });
        kropki.forEach((kropka, i) => {
          kropka.classList.toggle('is-active', i === biezacy);
          if (i === biezacy) kropka.setAttribute('aria-current', 'true');
          else kropka.removeAttribute('aria-current');
        });
      };

      const zatrzymaj = () => {
        clearInterval(zegar);
        zegar = null;
      };
      const uruchom = () => {
        zatrzymaj();
        if (!co || wstrzymany || bezRuchu.matches || document.hidden) return;
        zegar = setInterval(() => pokaz(biezacy + 1), co * 1000);
      };
      const przejdz = (n) => {
        pokaz(n);
        uruchom();
      };

      slajdy.slice(1).forEach((slajd) => { slajd.inert = true; });
      hero.querySelector('[data-hero-prev]')?.addEventListener('click', () => przejdz(biezacy - 1));
      hero.querySelector('[data-hero-next]')?.addEventListener('click', () => przejdz(biezacy + 1));
      kropki.forEach((kropka) => {
        kropka.addEventListener('click', () => przejdz(Number(kropka.dataset.heroDot)));
      });

      let startX = null;
      let startY = 0;
      hero.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse') return;
        startX = e.clientX;
        startY = e.clientY;
      });
      hero.addEventListener('pointerup', (e) => {
        if (startX === null) return;
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;
        startX = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) przejdz(biezacy + (dx < 0 ? 1 : -1));
      });
      hero.addEventListener('pointercancel', () => { startX = null; });

      const wstrzymaj = (tak) => {
        wstrzymany = tak;
        uruchom();
      };
      hero.addEventListener('mouseenter', () => wstrzymaj(true));
      hero.addEventListener('mouseleave', () => wstrzymaj(false));
      hero.addEventListener('focusin', () => wstrzymaj(true));
      hero.addEventListener('focusout', (e) => {
        if (!hero.contains(e.relatedTarget)) wstrzymaj(false);
      });
      document.addEventListener('visibilitychange', uruchom);

      uruchom();
    });
  };

  const init = () => {
    initWideo(document);
    initHero(document);
    initCarousels(document);
    initProjectFilters(document);
    initProjectZoom(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
